import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'i-hidable-text',
  templateUrl: './hidable-text.component.html',
  styleUrls: ['./hidable-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HidableTextComponent {
  @Input() title: string;
}
